/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-23-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import history from 'src/routes/history';

class CampaignCarousel extends Component<Props> {
  render() {
    const { campaignBanners = [] } = this.props;
    if (campaignBanners.length <= 0) return null;
    const banner = campaignBanners[0];
    return (
      <div
        className={`BC-CampaignBanner__DashboardV4`}
        onClick={() => this.handleOpenLink(banner.url)}>
        <img className="full-width" src={banner.image.source} alt={banner.name} />
      </div>
    );
  }

  // Handle open link
  handleOpenLink = url => {
    if (_.startsWith(url, '/')) {
      history.push(url);
    } else window.open(url, '_blank');
  };
}

const mapStateToProps = (state, props) => {
  const allCampaignBanners = _.get(state.dashboardV3, 'campaignBanners', []);
  const campaignBanners = _.filter(
    allCampaignBanners,
    campaignBanner => campaignBanner.type === 'middle'
  );
  return {
    campaignBanners
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(CampaignCarousel));
